<template>

  <div>
    <v-switch v-model="isEnabled"/>
  </div>

</template>

<script>

export default {
  name: 'NotifSwitchButton',
  props: ['item'],
  methods: {
    changeEnabledState () {
      console.log('aaaaaaaaah')
    }
  },
  computed: {
    isEnabled: {
      get: function () {
        return !this.item.disabled
      },
      set: function () {
        let notif = this.item
        notif.disabled = !notif.disabled
        this.$store.dispatch('patchNotification', {
          id: notif.id,
          patch: notif
        })
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/NotifSwitchButton.vue